import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IGalleryImageDescription } from './ngx-gallery-image.model';

@Component({
  selector: 'ngx-gallery-description',
  templateUrl: './ngx-gallery-description.component.html',
  styleUrls: ['./ngx-gallery-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxGalleryDescriptionComponent {
  @Input() data: IGalleryImageDescription;
}
